export default {
    general: {
        person: 'Адам',
        role: 'Рөлі',
        quit: 'Шығу',
        search: 'Іздеу',
        cancel: 'Болдырмау',
        reset: 'Қалпына келтіру',
        next: 'Алға',
        back: 'Артқа',
        selectCert: 'Сертификат таңдау',
        print: 'Мөр',
        dealer: 'Салық төлеуші',
        inspector: 'Салық инспекторы',
        admin: 'Администратор',
        actions: 'Әрекеттер',
        details: 'Анығырақ',
        additional: 'Қосымша',
        hide: 'Жасыру',
        name: 'Аты',
        create: 'Жасау',
        createNew: 'Жаңасын жасау',
        add: 'Қосу',
        edit: 'Өзгерту',
        save: 'Сақтау',
        iin: 'ЖСН',
        iinbin: 'ЖСН/БСН',
        select: 'Мәнді таңдаңыз',
        taxpayerCabinet: 'Сіз салық төлеушінің кабинетіндесіз',
        attachment: 'Тіркеме',
        smsCode: 'SMS коды',
        smsCodeSended: '{0} нөміріне SMS-хабарлама жіберілді, оны тіркеуді аяқтау және сертификатты алу үшін осында енгізу қажет.',
        authSuccess: 'Сіз сәтті аутентификация жасадыңыз!',
        pressToDownload: 'Егер сертификат автоматты түрде жүктелмесе, басыңыз',
        here: 'Осында',
        pressToLogin: 'Сертификатты пайдалана отырып кіру үшін "{0}" басыңыз.',
        haveNcaCert: 'Менде ҰКО ҚР сертификаты бар',
        noData: 'Деректер табылмады, іздеу жасаңыз',
        enterValue: 'Іздеу жасау үшін енгізіңіз',
        fromDate: 'бастап',
        toDate: 'дейн',
        lastDay: 'Соңғы күні',
        last12Hours: 'Соңғы 12 сағатта',
        lastHour: 'Соңғы 1 сағатта',
        nextPage: 'Келеси бет',
        prevPage: 'Алдыңғы бет',
        download: 'Жүктеу'
    },
    menu: {
        home: 'АЖО',
        login: 'Кіру',
        help: 'Көмек',
        reports: 'Есептер',
        createReport: 'Жаңа есеп жасау',
        reportDetails: 'Есеп туралы деректер',
        reportViewLog: 'Шолу журналы',
        profile: 'Профилі',
        dealers: 'Салық төлеушілер',
        dealerDetails: 'Салық төлеушінің кабинеті',
        createDealer: 'Салық төлеушіні қосыңыз',
        editDealer: 'Салық төлеуші туралы деректі өзгерту',
        persons: 'Адамдар',
        audit: 'Аудит',
        addressInfo: 'Мекенжай туралы деректер',
        attributes: 'Параметрлер',
        systemAttributes: 'Жүйелік параметрлер',
        kkmAttributes: 'KKM параметрлер',
        editAttribute: 'Параметрді өзгерту',
        createPerson: 'Адамды қосу',
        editPerson: 'Адам туралы деректі өзгерту',
        tickets: 'Чектер',
        ticketDetails: 'Чектегі деректер',
        sellReturn: 'Қайтару',
        moneyPlacements: 'Инкассация/толықтыру',
        moneyPlacementDetails: 'Инкассация/толықтыру деректері',
        kkms: 'БКМ',
        blockedKkms: 'Бұғатталған БКМ-дер',
        createKkm: 'Жаңа БКМ жасау',
        editKkm: 'БКМ өзгерту',
        setOfdData: 'ФДО деректерін орнату',
        startFiscalization: 'Фискализацияның басталуы',
        stopFiscalization: 'Фискализацияның тоқтауы',
        setCashier: 'Әдеп бойынша кассирді орнату',
        revokeCert: 'Сертификат пікірі',
        setDealer: 'Салық төлеушінің байланыстыруы',
        setBlockStatus: 'БКМ-ді бұғаттау/бұғаттан шығару',
        setOfdUnblock: 'ФДО деректері бойынша бұғаттан шығару',
        setOfdWork: 'Жұмыс жасайтын куйге аудару',
        setPoint: 'Сатылым нүктелерін орнату'
    },
    role: {
        '1': 'Администратор',
        '3': 'Салық төлеуші',
        '4': 'Салық инспекторы',
        '5': 'Оператор'
    },
    errors: {
        error: 'Қате',
        unknownError: 'Күтпеген қате пайда болды, қолдау қызметіне хабарласыңыз.',
        selectDealer: 'Кассалық бақылау машинасын көру үшін салық төлеушіні таңдау керек.',
        cantGetDealerInfo: 'Салық төлеуші туралы ақпарат алынбады, қайта кіріп көріңіз.',
        cantGetUserInfo: 'Сіздің жеке тұлғаңыз туралы ақпарат алынбады, қайта кіріп көріңіз.',
        passwordDontMatch: 'Құпия сөздер сәйкес келмейді',
        passwordNotValid: 'Құпия сөз жүйенің талаптарына сәйкес келмейді',
        '3': 'Көрсетілген логин табылмады (тиісті сертификат жоқ)',
        '6': 'Көрсетілген логинмен сертификат криптожүйеде бар (кері байланыс қажет)',
        '101': 'Қатынау қатесі',
        '102': 'Функцияны орындау үшін барлық қажетті параметрлер берілмеді',
        '110': 'Берілген деректердің логикасын бұзу',
        '111': 'Сәйкестендіргіш табылмады',
        '201': 'Қолданушы табылмады',
        '202': 'Авторизация Қолданушы бұғатталған',
        '203': 'Авторизация Құпия сөзін енгізі мүмкіндігі асып кетті',
        '204': 'Логин немесе құпия сөз қате',
        '205': 'Қолданушы жүйеде тіркелген',
        '207': 'Авторизация крито-кілт арқылы болу қажет',
        '209': 'SMS код дұрыс емес',
        '301': 'Дилер жүйеде бар',
        '306': 'Бақылау кассалық машинасы бұрыннан бар',
        '307': 'Салық инспекциясы табылмады',
        '404': 'бет табылмады',
        '604': 'Криптосервис Сервер қол жетімді емес немесе деректер дұрыс қалыптастырылмады',
        '607': 'Криптосервис: Алиас (логин) сертификат қоймасында табылмады',
        '608': 'Криптосервис: Сертификаттар сәйкес келмейді',
        '999': 'Ерекше жағдай. Мұның себебін анықтау қажет. Логтарды қара.'
    },

    report: {
        type: 'Есеп түрі',
        types: {
            default: 'Есеп',
            REPORT_Z: 'Z-есеп',
            Z_REPORT: 'Z-есеп',
            REPORT_X: 'X-есеп',
            FISCAL_PERIOD_REPORT: 'Кезең ішіндегі фискалдық есеп',
            FISCAL_PERIOD_REPORT_V2: 'Кезең ішіндегі фискалдық есеп',
            CASHIER_REPORT: 'Кассирлер туралы есеп',
            SECTION_REPORT: 'Бөлім туралы есеп'

        },
        viewLog: {
            viewDate: 'Есепті қараудың күні мен уақыты'
        },
        createDate: 'Құру күні',
        shiftNumber: 'Ауысым нөмірі',
        shiftOpenDate: 'Ауысымды ашу күні мен уақыты',
        shiftCloseDate: 'Ауысымды жабу күні мен уақыты',
        operations: 'Барлық бөлімдердің жалпы санының нәтижелері',
        bySections: 'Секция бойынша есеп',
        section: 'Секция',
        sections: 'Әрбір бөлімдегі операциялардың нәтижелері',
        totalResults: 'Қорытынды операциялық нәтижелер',
        moneyPlacements: 'Қолма-қол ақша операциясының нәтижелері',
        withdrawal: 'Төлемдер',
        deposit: 'Енгізілген',
        buy: 'Сатып алудың',
        buyReturn: 'Сатып алуды қайтару',
        sell: 'Сатудың',
        sellReturn: 'Сатуды қайтару',
        count: 'Саны',
        sum: 'Сома',
        fromDate: 'Кезеңнің басы',
        toDate: 'Кезеңнің аяғы',
        viewHistory: 'Көрініс тарихы',
        createdMessage: 'Есепті жасау тапсырмасы сәтті құрылды.',
        tax: 'Салық',
        taxTurnover: 'Салық бойынша айналым',
        taxType: {
            NDS: 'НДС'
        },
        reportWithDamping: 'Өтелген есеп',
        reportWithoutDamping: 'Өтеусіз есеп',
        startShiftNonNullableSums: {
            buy: 'Аусым басындағы сатып алудың нөлденбейтін сомасы',
            buyReturn: 'Аусым басындағы сатып алуды қайтаратын нөлденбейтін сома',
            sell: 'Аусым басындағы сатудың нөлденбейтін сомасы',
            sellReturn: 'Аусым басындағы сатуды қайтаратын нөлденбейтін сома'
        },
        closeShiftNonNullableSums: {
            buy: 'Сатып алудың нөлденбейтін сомасы',
            buyReturn: 'Сатып алуды қайтарудың нөлденбейтін сомасы',
            sell: 'Сатудың нөлденбейтін сомасы',
            sellReturn: 'Сатуды қайтарудың нөлденбейтін сомасы'
        },
        ticketOperations: {
            buy: 'Сатып алу чектерін',
            buyReturn: 'Сатып алу чектерін қайтару',
            sell: 'Сату чектерін',
            sellReturn: 'Сатуды қайтару чектерін'
        },
        paymentType: {
            cash: 'Қолма-қол ақшамен',
            card: 'Төлем картасымен',
            credit: 'Кредитпен',
            tare: 'Таромен'
        },
        cashSum: 'Кассадағы қолма-қол ақша',
        revenue: 'Түсім',
        canceledTickets: 'Жойылған чектерді',
        byShifts: 'Ауысым бойынша есеп',
        shift: 'Ауысым',
        discounts: 'Жеңілдік нәтижелері',
        markups: 'Жиынтық маржа',
        summaryDiscounts: 'Кезеңдегі жеңілдіктер сомасы',
        summaryMarkups: 'Кезеңдегі маржаның жалпы сомасы',
        summaryOperations: 'Кезеңдегі операциялардың сомасы'
    },
    person: {
        lastname: 'Тегі',
        firstname: 'Аты',
        middlename: 'Әкесінің аты',
        fio: 'Аты-жөні Тегі Аты Әкесінің аты',
        phone: 'Телефон',
        login: 'Логин',
        newLogin: 'Жаңа логин',
        password: 'Құпия сөз',
        newPassword: 'Жаңа құпия сөз',
        confirmPassword: 'Құпия сөзді қайталаңыз',
        address: 'Мекен жайы',
        newAddress: 'Жаңа мекен жайы',
        house: 'Үй',
        selectRole: 'Рөльді таңдаңыз',
        enabled: 'Жүйеде әрекет етеді',
        unlimitedTimeoutSession: 'Сессияның шектеусіз қызмет көрсету мерзімі',
        authType: 'Авторизация түрі',
        authTypes: {
            '100': 'Құпия сөз',
            '101': 'Сертификат',
            '102': 'Ұлттық куәландырушы орталығының сертификаты'

        },
        authKey: 'Авторизация үшін сертификат',
        regdate: 'Тіркелу уақыты',
        updatedMessage: 'Тұлға туралы жеке ақпарат сәтті жаңартылды',
        certRevokeConfirmation: 'Сіз шынымен "{0}" пайдаланушы сертификатын қайтарып алғыңыз келе ме?',
        certRevokedMessage: 'Сертификат сәтті қайтарылды',
        typeIin: 'Салық төлеушінің ЖСН/БСН енгізіңіз',
        dealerSetMessage: 'Салық төлеуші сәтті байланыстырылды',
        passwordChangedMessage: 'Құпия сөз сәтті өзгертілді',
        passwordRequirements: 'Бас әріптерден, араб цифрларынан және арнайы таңбалардан тұратын латын әріптері болуы керек: @$!%*?&_'

    },
    kkm: {
        label: 'Бақылау-Кассалық Машинасы',
        cashierCode: 'Оператор коды',
        cashierName: 'Оператор атауы',
        cashierSetMessage: 'Кассир-оператор сәтті орнатылды',
        inspectionName: 'Салық инспекциясының атауы',
        inspectionCode: 'Салық инспекциясының коды',
        registration: 'Тіркеу нөмірі',
        identification: 'Сәйкестендіру нөмірі',
        factoryNum: 'Зауыттық нөмірі',
        timezone: 'Бақылау-кассалық машинасының уақытша аймағы',
        cashAmount: 'Касса бойынша ағымдағы қалдық',
        kkmSfdNum: 'Фискалды деректер серверіндегі сәйкестендіргіш',
        enabled: 'Фискалды деректер серверіне қосылу',
        ofdConnected: 'Фискалды деректер операторына қосылу',
        openDate: 'Бақылау-Кассалық Машинасы әрекеттінің басталу күні ',
        closeDate: 'Бақылау-Кассалық Машинасының әрекет ету мерзімнің өту күні',
        startFiscalDate: 'фискализациялауды бастау күні мен уақыты',
        kkmId: 'Фискалды деректер операторындағы сәйкестендіргіш',
        ofdToken: 'Фискалды деректер операторының токені',
        ofdSelectString: 'Фискалды деректер операторы',
        selectOfdConnection: 'Фискалды деректер операторын таңдаңыз',
        ofdConnectionString: 'Фискалды деректер операторына қосылым жолы',
        publicKey: 'Бақылау-Кассалық Машинасының ашық кілті',
        canChangePublicKey: 'Бақылау-Кассалық Машинасының ашық кілтін өзгерту мүмкіндігі',
        defaultOperator: 'Үнсіз келісім бойынша операторы',
        isBlocked: 'Бұғатталған',
        blocked: 'Бұғатталу белгісі',
        blockStatusSetMessage: 'Бұғатталу күйі сәтті өзгертілді',
        pointTitle: 'Сату орнының атауы',
        pointAddress: 'Сату орнының мекен-жайы',
        house: 'Үй',
        status: 'Күйі',
        blockDate: 'Бұғатталу күні',
        blockMessage: 'Бұғатталу түсініктемесі',
        ofdStatus: 'Фискалды деректер операторының күйі',
        ofdBlockDate: 'Фискалды деректер операторын бұғаттау күні',
        ofdBlockMessage: 'Фискалды деректер операторын бұғаттау түсініктемесі',
        register: 'Тіркеу',
        unregister: 'Тіркеуден шығару',
        comment: 'Түсініктеме',
        createdMessage: 'Бақылау-Кассалық Машинасы сәтті құрылды. Идентификатор нөмірі: {0}',
        ofdDataSetMessage: 'Фискалды деректер операторының токені сәтті сақталды.',
        toKkmList: 'Бақылау-Кассалық Машинасының тізіміне',
        pointSetMessage: 'Сату орны сәтті орнатылды',
        setOfdWorkConfirmation: '{0} Бақылау-Кассалық Машинасы жұмыс жағдайына аударылады.',
        ofdWorkSetMessage: 'Бақылау-Кассалық Машинасы жұмыс жағдайына сәтті аударылды.',
        mode: 'Режим',
        programMode: 'Режим программирования',
        programModeUserLabel: 'Выполнено',
        workMode: 'Режим продаж',
        programTask: 'Переход',
        programModeSetMessage: 'Режим программирования успешно установлен',
        workModeSetMessage: 'Режим продаж успешно установлен',
        statusOfdShortName: {
            'READY': 'Онлайн',
            'BLOCKED': 'Заблокирован',
            'ERROR': 'Ошибка',
            'ERROR_TEMP': 'Автономный режим',
            'WAIT_OFD_CONFIRM': 'Подтверждение регистрационных данных'
        },
        statusOfdFullName: {
            'READY': 'В рабочем состоянии',
            'BLOCKED': 'Заблокирован в ОФД',
            'ERROR': 'Остановлен, требуется вмешательство специалиста',
            'ERROR_TEMP': 'Остановлен (временная ошибка)',
            'WAIT_OFD_CONFIRM': 'Подтверждение регистрационных данных'
        },
        statusShortName: {
            'CREATED': 'Создан',
            'READY': 'В работе',
            'WAIT_OFD': 'Ожидание данных ОФД',
            'STOP': 'Снят с учета',
            'CLOSED': 'Закрыт'
        },
        statusFullName: {
            'CREATED': 'Создан в системе',
            'READY': 'В рабочем состоянии',
            'WAIT_OFD': 'Ожидание данных ОФД',
            'STOP': 'Снят с учета',
            'CLOSED': 'Работа ККМ в системе завершена'
        },
        clientStatus: 'Терминал статусы',
        clientStatusMessage: 'Терминал статусы туралы ақпрат',
        clientStatusDate: 'Терминал статусы өзгерген күні',
        setCanChangePublicKeyConfirmText: 'Вы действительно хотите установить признак регистрации публичного ключа?',
        setCanChangePublicKeySuccess: 'Признак регистрации публичного ключа установлен'
    },
    ticket: {
        shiftDocumentNumber: 'Ауысымдағы чек нөмірі',
        offlineTicketNumber: 'Дербес чек нөмірі',
        onlineTicketNumber: 'Фискалды чек нөмірі',
        debet: 'Бақылау-Кассалық Машинасы бойынша кіріс/шығыс',
        totalAmount: 'Чек соммасы',
        status: 'Чек жайы',
        cashierName: 'Кассир-оператор',
        txnClientDate: 'Бақылау-Кассалық Машинасыдағы транзакция күні',
        operationTypes: {
            default: 'Операция түрі',
            SELL: 'Сату'
        },
        itemName: 'Атауы',
        section: 'Бөлім',
        quantity: 'Саны',
        price: 'Бағасы',
        total: 'Сомасы',
        taken: 'Қабылданды',
        change: 'Қайтарым',
        sellReturnConfirmation: 'Сіз шынымен {0} чек бойынша қайтару жасағыңыз келеме?',
        sellReturnedMessage: 'Чек бойынша қайтару қайтарымы сәтті құрылды.'
    },
    moneyPlacement: {
        shiftDocumentNumber: 'Ауысымдағы реттік номір',
        shiftNumber: 'Ауысымдағы нөмір',
        debet: 'Бақылау-Кассалық Машинасы бойынша кіріс/шығыс',
        amount: 'инкассалау/толықтыру сомасы',
        txnClientDate: 'Бақылау-Кассалық Машинасындағы транзакция күні',
        collection: 'Инкассация',
        replenishment: 'Толықтыру',
        sumOfCollection: 'Инкассалау сомасы',
        sumOfReplenishment: 'толықтыру сомасы'
    },
    dealer: {
        name: 'Атауы',
        industry: 'Қызмет түрі',
        updatedMessage: 'Салық төлеуші жайлы ақпарат сәтті жаңартылды ',
        regDateTime: 'Тіркелу күні',
        phone: 'Телефон нөмірі',
        address: 'Мекен-жайы',
        newAddress: 'Жаңа мекен-жайы',
        house: 'үй нөмірі',
        ndsPayer: 'ҚҚС төлеушісі болып табылады',
        ndsCertificateSeries: 'ҚҚС куәлігінің сериясы ',
        ndsCertificateNum: 'ҚҚС куәлігінің нөмірі'
    },
    audit: {
        dateTime: 'Күні',
        event: 'Оқиға',
        sysObject: 'Нысан',
        subject: 'Субъект',
        success: 'Табыс',
        yes: 'Иә',
        no: 'Жок'
    },
    attribute: {
        code: 'Атрибут коды',
        value: 'Мағынасы',
        comment: 'Комментарий',
        updatedMessage: 'Жүйелік параметр сәтті жаңартылды'
    },
    addressInfo: {
        operationType: 'Операция түрі',
        selectType: 'Сізге қажетті {0} нысанының түрін таңдаңыз',
        area: 'Облыс',
        district: 'Облыс ауданы',
        city: 'Қала',
        cityDistrict: 'Қала ауданы',
        microDistrict: 'Мөлтек аудан',
        street: 'Көше',
        house: 'Үй',
        newValue: 'Жаңа мағынасы',
        addressCreatedMessage: 'Мекенжай сәтті қосылды',
        addressUpdatedMessage: 'Мекенжай сәтті жаңартылды'
    }
}
